<template>
  <div class="text-center">
    <div class="header px-2 pb-1">
      <img
        alt="success"
        width="66px"
        :src="topUpInprocessImg"
      >
      <h3 class="my-1">
        Topup inprocess
      </h3>
      <p>Thanks you for your purchase. Please wait a moment the money will return to your balance.</p>
    </div>
    <div class="summary p-2">
      <h4 class="text-left mb-2">
        Summary
      </h4>
      <div class="sm-item mb-1 flex-wrap">
        <div class="font-14 text-placeholder">
          Client
        </div>
        <strong>
          {{ fullName }}
        </strong>
      </div>
      <div class="sm-item mb-1">
        <div class="font-14 text-placeholder">
          Amount
        </div>
        <strong>
          {{ localStringFormat(amount) }} USD
        </strong>
      </div>

      <div
        v-if="paymentMethod.paymentMethod"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div class="font-14 text-placeholder">
          Payment method
        </div>
        <div class="d-flex align-items-center">
          <img
            :src="getBrandIcon(paymentMethod.paymentMethod)"
            alt="payment"
            style="margin-right: 6px;width: 26px"
          >
          <strong>{{ convertNamePayment(paymentMethod.paymentMethod) }}</strong>
        </div>
      </div>

      <div
        v-else-if="paymentMethod.type"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div class="font-14 text-placeholder">
          Payment method
        </div>
        <div class="d-flex align-items-center">
          <img
            :src="getBrandIcon(paymentMethod.type)"
            alt="payment"
            style="margin-right: 6px;width: 26px"
          >
          <strong>{{ paymentMethod.type }}</strong>
        </div>
      </div>

      <div class="sm-item mb-1">
        <div class="font-14 text-placeholder">
          Currency
        </div>
        <div>
          <strong>{{ paymentMethod.value }}</strong>
        </div>
      </div>

      <div
        v-if="paymentMethod.bankLocation"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div class="font-14 text-placeholder">
          Account location
        </div>
        <div v-if="amount">
          <img
            v-if="paymentMethod.icon"
            :src="paymentMethod.icon"
            width="18px"
            alt="coin"
            style="margin-right: 6px"
          >
          <strong>{{ paymentMethod.bankLocation }}</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>

      <div class="sm-item mb-1">
        <div class="font-14 text-placeholder">
          Service charge
        </div>
        <strong class="theme-text-primary">{{ serviceCharge }} USD</strong>
      </div>

      <div
        v-if="tax"
        class="sm-item mb-1"
      >
        <div class="font-14 text-placeholder">
          Tax
        </div>
        <div>
          <strong class="theme-text-primary">{{ tax }} USD</strong>
        </div>
      </div>

      <div
        v-if="tipAmount > 0"
        class="sm-item mb-1"
      >
        <div
          class="font-14 text-placeholder"
        >
          Tip
        </div>
        <strong
          class="theme-text-primary"
        >{{ tipAmountTxt }} USD</strong>
      </div>

      <hr class="hr-custom">
      <div class="sm-item">
        <div class="font-14 text-placeholder text-left">
          Total Amount = Amount + Service charge {{ tax ? '+ Tax' : '' }} {{ tipAmount > 0 ? '+ Tip' : '' }}
        </div>
      </div>
      <h3 class="mt-2 text-left">
        {{ totalAmount }} USD
      </h3>
    </div>

    <!-- <div class="action mt-2 text-center">

      <b-button
        variant="primary"
        class="ml-1"
        @click="$router.history.push('/ads-account')"
      >
        Show me Ad Account
      </b-button>
    </div> -->
    <div
      v-if="isShowBtnBackToDemoView"
      class="action mt-2 text-center"
    />
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import _get from 'lodash/get'
import { bus } from '@/plugins/bus'

import numberFormatMixin from '@/mixins/numberFormatMixin'
import paymentMixin from '@/mixins/paymentMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import { PAYMENT_METHOD } from '@/constants'

const { mapGetters } = createNamespacedHelpers('payment')
const { mapGetters: mapGettersAuth } = createNamespacedHelpers('auth')

export default {
  mixins: [numberFormatMixin, generalConfigsMixin, paymentMixin, stepGuideMixin],
  props: {
    paymentMethod: {
      type: Object,
      required: true,
    },

    // eslint-disable-next-line vue/require-default-prop
    detailInfo: {
      type: Object,
      required: false,
    },

    transfer: {
      type: Object,
      required: true,
    },

    amount: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      historyTicket: {},
    }
  },

  watch: {
    listTicket: {
      handler(ticket) {
        if (ticket.paging.total > 0) {
          const airwallexTicket = ticket?.content?.find(transaction => transaction.details.paymentMethod === PAYMENT_METHOD.AIRWALLEX)
          if (airwallexTicket) {
            this.historyTicket = airwallexTicket
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    ...mapGetters(['listCard', 'loading']),
    ...mapGettersAuth(['user']),

    isShowBtnBackToDemoView() {
      return this.hasStepGuide && this.user?.data?.balance > 0
    },

    fullName() {
      const fullName = _get(this.user, ['data', 'fullName'], '')
      const email = _get(this.user, ['data', 'email'], '')
      return fullName || email
    },

    percentFee() {
      return this.user?.data?.plans?.transferFee?.airWallex || 0
    },

    serviceCharge() {
      if (!this.detailInfo) {
        return this.amountFormat(this.percentFee * this.amount).toLocaleString('en-US')
      }

      if (this.detailInfo?.serviceCharge) {
        return this.detailInfo?.serviceCharge
      }

      return 0
    },

    totalAmount() {
      if (!this.detailInfo) {
        const fee = this.amountFormat(this.percentFee * this.amount)
        const tax = this.amountFormat(this.taxRate * this.amount)
        const tip = this.tipAmount || 0
        return (this.amount + fee + tax + tip).toLocaleString('en-US')
      }

      const fee = this.detailInfo?.serviceCharge
      const tax = this.detailInfo?.taxCharge
      const tip = this.detailInfo?.tipAMAmount || 0

      return (this.amount + fee + tax + tip).toLocaleString('en-US')
    },

    tipAmount() {
      if (this.detailInfo?.tipAMAmount) {
        return this.detailInfo?.tipAMAmount
      }

      return 0
    },

    tipAmountTxt() {
      return this.amountFormat(this.tipAmount)
        .toLocaleString('en-US')
    },

    percentTaxTxt() {
      return `${(this.taxRate * 100).toFixed(2)}%`
    },

    tax() {
      if (!this.detailInfo) {
        return this.amountFormat(this.taxRate * this.amount).toLocaleString('en-US')
      }

      if (this.detailInfo?.taxCharge) {
        return this.detailInfo?.taxCharge
      }

      return 0
    },
  },

  created() {
    bus.$on('set-invoice-data', data => {
      this.amount = data.amount
    })
  },
}
</script>
<style lang="scss" scoped>
  .hr-custom{
    border-top: 1px solid #EEEEEE;
  }

  .summary{
    border-radius: var(--border-radius-base);
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
    background-color: #fff;
  }

  .sm-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>
